import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

function HoursInput({ changeValue, change, label, loading }) {

    const [defaultValue, setDefaultValue] = useState(null);

    useEffect(() => {

        if (changeValue != undefined) {
            const hour = changeValue.hour;
            const minute = changeValue.minute;

            setDefaultValue(hour * 60 + minute);
        }


    }, [changeValue]);


    function change_(e) {
        const val = parseInt(e.target.value);
        const hour_all = val / 60;
        const hour = Math.floor(hour_all);
        const minute = hour_all === hour ? 0 : 30;

        change({ hour: hour, minute: minute });
    }



    return (
        <Form.Group key={defaultValue}>
            <Form.Label>{label}</Form.Label>
            <Form.Select key={Math.random()} defaultValue={defaultValue} onChange={(e) => change_(e)} disabled={loading}>
                <option value={-1}>Не выбрано</option>
                <option value={0} >00:00</option>
                <option value={30}>00:30</option>
                <option value={60} >01:00</option>
                <option value={90} >01:30</option>
                <option value={120} >02:00</option>
                <option value={150} >02:30</option>
                <option value={180} >03:00</option>
                <option value={210} >03:30</option>
                <option value={240} >04:00</option>
                <option value={270} >04:30</option>
                <option value={300} >05:00</option>
                <option value={330} >05:30</option>
                <option value={360} >06:00</option>
                <option value={390} >06:30</option>
                <option value={420} > 07:00</option>
                <option value={450} > 07:30</option>
                <option value={480} >08:00</option>
                <option value={510} >08:30</option>
                <option value={540} >09:00</option>
                <option value={570} >09:30</option>
                <option value={600} >10:00</option>
                <option value={630} >10:30</option>
                <option value={660} >11:00</option>
                <option value={690} >11:30</option>
                <option value={720} >12:00</option>
                <option value={750} >12:30</option>
                <option value={780} >13:00</option>
                <option value={810} >13:30</option>
                <option value={840} >14:00</option>
                <option value={870} >14:30</option>
                <option value={900} >15:00</option>
                <option value={930} >15:30</option>
                <option value={960} >16:00</option>
                <option value={990} >16:30</option>
                <option value={1020} >17:00</option>
                <option value={1050} >17:30</option>
                <option value={1080} >18:00</option>
                <option value={1110} >18:30</option>
                <option value={1140} >19:00</option>
                <option value={1170} >19:30</option>
                <option value={1200} >20:00</option>
                <option value={1230} >20:30</option>
                <option value={1260} >21:00</option>
                <option value={1290} >21:30</option>
                <option value={1320} >22:00</option>
                <option value={1350} >22:30</option>
                <option value={1380} >23:00</option>
                <option value={1410} >23:30</option>
            </Form.Select>
        </Form.Group>
    )
}

export default HoursInput;